module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-23.a8f623db.png";